import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, MenuItem, Typography, Alert } from '@mui/material';
import scadenzaApi from '../../api/scadenzaApi';
import contribuenteApi from '../../api/contribuenteApi';
import documentoApi from '../../api/documentoApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function ScadenzaCreatePage() {
  const [form, setForm] = useState({
    tipo: '',
    dataScadenza: '',
    importo: '',
    contribuenteId: '',
    documentoId: ''
  });

  const [contribuenti, setContribuenti] = useState([]);
  const [documenti, setDocumenti] = useState([]);
  const [err, setErr] = useState(null);

  const [params] = useSearchParams();
  const navigate = useNavigate();

  const documentoIdParam = params.get("documentoId");
  const contribuenteIdParam = params.get("contribuenteId");

  useEffect(() => {
    // Carica lista contribuenti solo se non già specificato
    if (!contribuenteIdParam) {
      contribuenteApi.list({ page: 0, size: 100 })
        .then(r => setContribuenti(r.data.content || []));
    }

    // Carica lista documenti
    documentoApi.list({ page: 0, size: 500 })
      .then(r => setDocumenti(r.data.content || []));
  }, []);

  useEffect(() => {
    // Se arrivo da DocumentoDetailPage → documentoId è preimpostato
    if (documentoIdParam) {
      setForm(f => ({ ...f, documentoId: documentoIdParam }));

      // Carico automaticamente il contribuente del documento
      documentoApi.get(documentoIdParam).then(r => {
        const doc = r.data;
        if (doc.contribuenteId) {
          setForm(f => ({ ...f, contribuenteId: doc.contribuenteId }));
        }
      });
    }

    // Se arrivo da ContribuenteDetailPage
    if (contribuenteIdParam) {
      setForm(f => ({ ...f, contribuenteId: contribuenteIdParam }));
    }
  }, [documentoIdParam, contribuenteIdParam]);

  const filteredDocumenti = form.contribuenteId
    ? documenti.filter(d => d.contribuenteId === Number(form.contribuenteId))
    : documenti;

  const submit = async (e) => {
    e.preventDefault();
    try {
      await scadenzaApi.create(form);

      if (form.documentoId) navigate(`/documenti/${form.documentoId}`);
      else if (form.contribuenteId) navigate(`/contribuenti/${form.contribuenteId}`);
      else navigate('/scadenze');

    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  return (
    <Container>
    <BackButtonDesktop />
      <Typography variant="h5">Crea Scadenza</Typography>
      {err && <Alert severity="error">{String(err)}</Alert>}

      <form onSubmit={submit}>
        <TextField
          fullWidth sx={{ my: 1 }}
          label="Tipo"
          value={form.tipo}
          onChange={e => setForm({ ...form, tipo: e.target.value })}
        />

        <TextField
          fullWidth sx={{ my: 1 }}
          label="Data Scadenza"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={form.dataScadenza}
          onChange={e => setForm({ ...form, dataScadenza: e.target.value })}
        />

        <TextField
          fullWidth sx={{ my: 1 }}
          label="Importo"
          type="number"
          value={form.importo}
          onChange={e => setForm({ ...form, importo: e.target.value })}
        />

        {/* CONTRIBUENTE - Disabilitato se già impostato */}
        <TextField
          select
          fullWidth
          sx={{ my: 1 }}
          label="Contribuente"
          value={form.contribuenteId}
          disabled={!!contribuenteIdParam || !!documentoIdParam}
          onChange={e => setForm({ ...form, contribuenteId: e.target.value })}
        >
          {contribuenti.map(c =>
            <MenuItem key={c.id} value={c.id}>
              {c.nome} {c.cognome}
            </MenuItem>
          )}
        </TextField>

        {/* DOCUMENTO - Disabilitato se già impostato */}
        <TextField
          select
          fullWidth
          sx={{ my: 1 }}
          label="Documento"
          value={form.documentoId}
          disabled={!!documentoIdParam}
          onChange={e => setForm({ ...form, documentoId: e.target.value })}
        >
          {filteredDocumenti.map(d =>
            <MenuItem key={d.id} value={d.id}>
              {d.tipo} (ID {d.id})
            </MenuItem>
          )}
        </TextField>

        <Button variant="contained" type="submit">Crea</Button>
      </form>
    </Container>
  );
}